<svc-dialog #dialog [hasActions]="false" [hideCloseButton]="hideCloseButton">
  <mat-icon
    svc-dialog-title-icon
    svgIcon="heroicons_solid:exclamation-circle"
  ></mat-icon>

  <div svc-dialog-title class="min-w-0">
    <span
      #titleTip="svzTruncatedTooltip"
      class="block truncate"
      [svzTruncatedTooltip]="title | transloco"
      [zTooltip]="titleTip.tooltip()"
      zPosition="bottom"
      >{{ title | transloco }}</span
    >
  </div>

  <div svc-dialog-content class="m-4">
    <p class="px-2">
      {{ text | transloco }}
    </p>

    <div mat-dialog-actions class="flex justify-end p-2 mt-5">
      <div class="flex gap-2">
        @if (cancelText !== '') {
          <button
            mat-button
            type="button"
            id="svc-confirm-dialog-button-cancel"
            class="bg-white text-copilot-primary rounded-lg px-4 border border-solid border-copilot-primary min-h-8"
            (click)="cancel()"
          >{{ cancelText | transloco}}</button>
        }

        <button
          mat-button
          id="svc-confirm-dialog-button-confirm"
          type="button"
          class="bg-[#EC221F] text-white rounded-lg px-5 min-h-8 ml-2"
          (click)="ok()"
        >{{ okText | transloco }}</button>

      </div>
    </div>
  </div>
</svc-dialog>




